module.exports = __webpack_public_path__ + "img/0.5e201502.jpg";